import React, {useState} from 'react';
import {motion} from 'framer-motion';
import {animationValues, transitionValues} from '../utils/pageTransitions';
import logo from '../assets/images/logo.png';
import {useCookies} from 'react-cookie';
import {Link, useNavigate} from 'react-router-dom';
import {adminLogin} from '../redux/actions/adminActions';
import {connect} from 'react-redux';
import Spinner from '../components/reusables/spinner';
import InputField from '../components/reusables/input';
import '../styles/auth.css';

function AdminLogin({login_admin}) {
    const [cookies,
        setCookie] = useCookies(['token']);
    const navigate = useNavigate();

    const [showPassword,
        setShow] = useState(false);

    const [isLoading,
        setIsLoading] = useState(false);

    const [formData,
        setData] = useState({username: '', password: ''})

    const {username, password} = formData;

    const handleChange = (e) => {
        setData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleLoading = () => {
        setIsLoading(true);

        setInterval(() => {
            // setIsLoading(false)
        }, 4000)
    }

    const submit = (e) => {
        e.preventDefault();
        handleLoading();
        login_admin(formData, navigate, setCookie);
    }

    return (
        <motion.div
            initial='out'
            animate='in'
            exit='out'
            variants={animationValues}
            transition={transitionValues}>

            <div className="fullHeight admin">

                <div className="formHolder container center">
                    <div className="content vAlign">
                        <img src={logo} alt="" className='mAuto pb-5'/>
                        <div className="authCard alignOnly">
                            <div className="w-100">
                                <h2 className="sectionHead--mid textIsBold pt-3">Login</h2>

                                <form className='pt-3' onSubmit={submit}>
                                    <div className="pt-2 pb-2">
                                        <InputField
                                            type='text'
                                            placeholder='Email or Username'
                                            name='username'
                                            value={username}
                                            onChange={handleChange}/>
                                    </div>

                                    <div className="pt-2 pb-2">
                                        <InputField
                                            placeholder='Password'
                                            name='password'
                                            value={password}
                                            onChange={handleChange}
                                            type={showPassword
                                            ? 'text'
                                            : 'password'}
                                            icon
                                            iconClass={showPassword
                                            ? 'ri-eye-line'
                                            : 'ri-eye-close-line'}
                                            iconClick={() => setShow(!showPassword)}/>
                                    </div>

                                    <div className="spaceBetween mobileBlock">
                                        <Link to='/forgot'>
                                            <span className='textIsGreen sectionText'>
                                                Forget Password?
                                            </span>
                                        </Link>

                                        <div className="pt-3">
                                            {isLoading
                                                ? <button className="btn__filled textIsBold alignOnly w-100">Please Wait {''}
                                                        <Spinner/>
                                                    </button>
                                                : <button className="btn__filled textIsBold w-100">Login</button>
}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </motion.div>

    )
}

const mapDispatchToProps = (dispatch) => ({
    login_admin: (data, navigator, setCookie) => dispatch(adminLogin(data, navigator, setCookie))
})

export default connect(null, mapDispatchToProps)(AdminLogin)
